import _ from 'lodash'
import { menus } from './core/menu'
import EditorMenuItem from './EditorMenuItem'

export default {
  name: 'KEditorMenu',
  inject: ['context'],
  props: {},
  data() {
    return {}
  },
  watch: {},
  mounted() {
  },
  methods: {},
  render() {
    const style = {}

    const css = {
      'km-editor__menu-bar': true,
    }

    const attrs = {}

    const props = {}

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
    }

    return (
      <div
        {...data}
      >
        {
          _.map(menus, menu => {
            return menu.separator ? <div class="km-editor__menu-separator" />
              : <EditorMenuItem value={menu.value} />
          })
        }
      </div>
    )
  },
}
